import type React from "react"

import { NumberTicker } from "@/components/ui/number-ticker"
import { cn } from "@/lib/utils"

const toNumericMetric = (value: string): number | null => {
  const normalized = value.replaceAll(",", "").trim()
  if (!/^[-+]?\d+(\.\d+)?$/.test(normalized)) return null

  const parsed = Number(normalized)
  return Number.isFinite(parsed) ? parsed : null
}

export function MetricTile({
  label,
  value,
  detail,
  children,
  className,
}: {
  label: string
  value?: string
  detail?: string
  children?: React.ReactNode
  className?: string
}) {
  const resolvedValue = value ?? ""
  const numericValue = resolvedValue ? toNumericMetric(resolvedValue) : null

  return (
    <div className={cn("metric-tile", className)}>
      <div className="metric-label">{label}</div>
      <div className="metric-value">
        {children ? (
          children
        ) : numericValue === null ? (
          resolvedValue
        ) : (
          <NumberTicker
            value={numericValue}
            startValue={0}
            className="text-inherit dark:text-inherit"
          />
        )}
      </div>
      {detail ? (
        <div className="mt-2 text-sm text-muted-foreground">{detail}</div>
      ) : null}
    </div>
  )
}
